var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "w-input",
    _vm._b(
      {
        ref: "input",
        staticClass: "f-password",
        attrs: { type: "password", label: "password" },
        on: { input: _vm.input },
      },
      "w-input",
      { value: _vm.value, label: _vm.label, required: _vm.required },
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }